import React from "react";
import "./DeleteAccountPopupStyle.css";
import { getFipDisplayName } from "../../utils/fipUtils";

function DeleteAccountPopup({
  message,
  onPopup,
  fipId,
  accountNo,
  accountRefNo,
  fiType,
  accountType
}) {

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundColor: "rgba(0,0,0,0.6)",
      }}
      onClick={() => onPopup(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <h5 style={{ color: "red" }}>{message}</h5>
        <br />
        <div>
          <h6>Fip Name: {getFipDisplayName(fipId)}</h6>
          <h6>FI Type: {fiType}</h6>
          <h6>Account Type: {accountType}</h6>
          <h6>Account Number: {accountNo}</h6>
          <h6>Account Reference Number: {accountRefNo}</h6>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>
            <button
              type="submit"
              className="delete-btn"
              onClick={() => onPopup(true)}
            >
              Delete
            </button>
          </span>
          <span>
            <button
              type="submit"
              className="cancel-btn"
              onClick={() => onPopup(false)}
            >
              Cancel
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccountPopup;
